import { render, staticRenderFns } from "./RegisterStep3.vue?vue&type=template&id=53cd47ff"
import script from "./RegisterStep3.vue?vue&type=script&lang=js"
export * from "./RegisterStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports